import { TableActionsProps } from "./types/tableActionsProps";
import { ReactComponent as AutoRenew } from "../../../../icons/autorenew.svg";
import { ReactComponent as AutoRenewDisabled } from "../../../../icons/autorenewDisabled.svg";
import { ReactComponent as FindInPage } from "../../../../icons/find_in_page.svg";
import { ReactComponent as Visibility } from "../../../../icons/visibility.svg";
import { ReactComponent as Edit } from "../../../../icons/edit.svg";
import { ReactComponent as PersonAdd } from "../../../../icons/person_add.svg";
import { ReactComponent as Delete } from "../../../../icons/delete.svg";
import { ReactComponent as Close } from "../../../../icons/close.svg";
import { ReactComponent as DoNotDisturbOn } from "../../../../icons/do_not_disturb_on.svg";
import { ReactComponent as CheckCircle } from "../../../../icons/check_circle.svg";
import { ReactComponent as Mail } from "../../../../icons/mail.svg";
import { ReactComponent as Drafts } from "../../../../icons/drafts.svg";
import { ReactComponent as AttachFile } from "../../../../icons/attach_file.svg";
import { ReactComponent as ScanDelete } from "../../../../icons/scan_delete.svg";
import { ReactComponent as ScanDelete1 } from "../../../../icons/scan_delete-1.svg";
import { ReactComponent as AddCircleIcon } from '../../../../icons/add_circle.svg';
import { ReactComponent as ComputerIcon } from "../../../../icons/computer.svg";
import { ReactComponent as HourglassIcon } from "../../../../icons/hourglass_top.svg";
import { ReactComponent as AdminDecision } from "../../../../icons/assignment_late.svg";
import { iconStyle, iconStyleDisabled, iconStyleWithoutPointer } from "../../../../components/shared/stylization";
import './tableActions.scss';
import { ObjectType } from "../../../../contexts/types/card";
import { AdditionalIcon } from "../../additionalIcon/additionalIcon";
import { adminDecisionIconVisible, disableReportIcon } from "../../../../helpers/permissionsHelper";

const TableActions = (props: TableActionsProps) => {

    const PropsSVG: React.SVGAttributes<SVGSVGElement> = {
        style: iconStyle,
        width: 24,
        height: 24,
        fill: '#999490'
    }

    const PropsStrongSVG: React.SVGAttributes<SVGSVGElement> = {
        style: iconStyle,
        width: 24,
        height: 24,
        fill: '#453F3A'
    }

    const emptyCSS: React.CSSProperties = {
        display: 'inline-block',
        verticalAlign: 'middle',
        paddingRight: '5px',
        paddingLeft: '5px',
        width: '24px',
        height: '24px'
    }

    const tableActionsStyle = props.draggableStyle ? "draggableTableActions" : "tableActions tableActions-right"

    const renderEditState = (idField: string) => {
        return props.visibilityRows?.includes(props.row.original[idField])
            ? <Close title="zamknij widok edycji" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.closeClickHandler !== undefined) {
                    props.closeClickHandler(props.row.original);
                }
            }} />
            : <Edit title="edytuj" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.editClickHandler !== undefined) {
                    props.editClickHandler(props.row.original);
                }
            }} />
    }

    const renderReadState = (field: string, readState: string | number) => {
        return props.row.original.attributes[field] === readState
            ? <Drafts {...PropsSVG} title="Oznacz jako nieprzeczytane" onClick={(e) => {
                e.stopPropagation();
                if (props.readClickHandler !== undefined) {
                    props.readClickHandler(props.row, false);
                }
            }} />
            : <Mail {...PropsStrongSVG} title="Oznacz jako przeczytane" onClick={(e) => {
                e.stopPropagation();
                if (props.readClickHandler !== undefined) {
                    props.readClickHandler(props.row, true);
                }
            }} />
    }

    const renderAttachment = () => {
        const count = props.row.original.attributes.LICZBA_ZALACZNIKOW;
        return count > 0 && <AttachFile {...PropsSVG} title={`Liczba załączników ${count}`}/>
    }

    const renderIfImportant = () => {
        const isActive = props.row.original.attributes.CZY_WAZNY === 1;
        return isActive
            ? <ScanDelete1 {...PropsSVG} title="Odznacz ważność" className="tableAction-active" onClick={(e) => {
                e.stopPropagation();
                if (props.readClickHandler !== undefined) {
                    props.readClickHandler(props.row, false);
                }
            }} />
            : <ScanDelete {...PropsSVG} title="Oznacz jako ważna" onClick={(e) => {
                e.stopPropagation();
                if (props.readClickHandler !== undefined) {
                    props.readClickHandler(props.row, true);
                }
            }} />
    }

    const renderTaskSource = () => {
        const isLocal = props.row.original._isLocal;
        return isLocal
            ? <ComputerIcon {...PropsSVG} title="Komputer osobisty" />
            : <HourglassIcon {...PropsSVG} title="Poczekalnia" />
    }

    const checkIfKR = () => {
        return props.row.original.attributes.RODZAJ_OBIEKTU === ObjectType.KRO || props.row.original.attributes.RODZAJ_OBIEKTU === ObjectType.KRTZ;
    }

    const checkIfInWaitingRoom = () => {
        return props.row.original?.attributes?.POCZEKALNIA !== undefined && props.row.original?.attributes?.POCZEKALNIA === 1;
    }

    if (props.objectType === "taskList") {
        if(!props.row.original.attributes){
            props.row.original.attributes = props.row.original;
        }
        const waitingRoomRec = props.row.original.attributes;
        return (<div className={tableActionsStyle}>
            {adminDecisionIconVisible(waitingRoomRec.STAN_OBIEKTU_DOM, waitingRoomRec.RODZAJ_OBIEKTU) && 
                <AdminDecision title="podsumowanie analiz" style={iconStyle} className="tableActionsMainTablesIcons" onClick={(e) => {
                    e.stopPropagation();
                    if (props.adminDecisionHandler !== undefined) {
                        props.adminDecisionHandler(waitingRoomRec);
                    }
                }}/>}
            <Visibility title="podgląd formularza" style={iconStyle} className="tableActionsMainTablesIcons" onClick={(e) => {
                e.stopPropagation();
                if(!disableReportIcon(waitingRoomRec.STAN_OBIEKTU_DOM) && props.getPdfClickHandler !== undefined){
                    if(!props.row.original.attributes){
                        props.row.original.attributes = props.row.original;
                    }
                    props.getPdfClickHandler(props.row.original.attributes.ID.toString());
                }
            }}/>
            <Edit title="edytuj / weryfikuj" style={iconStyle} className="tableActionsMainTablesIcons" onClick={(e) => {
                e.stopPropagation();
                if (props.editClickHandler !== undefined) {
                    props.editClickHandler(props.row.original);
                }
            }} />
            {props.row.original?.attributes?.RODZAJ_OBIEKTU !== ObjectType.POO && props.row.original?.attributes?.RODZAJ_OBIEKTU !== ObjectType.POTZ ? 
            <PersonAdd title="przypisz edytora / weryfikatora" style={iconStyle} className="tableActionsMainTablesIcons" onClick={(e) => {
                e.stopPropagation();
                if (props.personAddClickHandler !== undefined) {
                    props.personAddClickHandler(props.row.original);
                }
            }} /> : <div style={iconStyleWithoutPointer} className="tableActionsMainTablesIcons"></div>}
        </div>)
    }
    else if (props.objectType === "taskListLocal") {
        return (<div className={tableActionsStyle}>
            <Edit title="edytuj / weryfikuj" style={iconStyle} className="tableActionsMainTablesIcons" onClick={(e) => {
                e.stopPropagation();
                if (props.editClickHandler !== undefined) {
                    props.editClickHandler(props.row.original);
                }
            }} />
        </div>)
    }
    else if (props.objectType === "elaborators") {
        return (
        <div ref={(node: any) => {if(props.addCommentBtnRef && !props.addCommentBtnVisible) props.addCommentBtnRef(node, props.row.original)}} className={tableActionsStyle} style={{position: "relative"}}>
            {!props.addCommentBtnVisible &&
                <Delete title="usuń" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                    e.stopPropagation();
                    if (props.deleteClickHandler !== undefined) {
                        props.deleteClickHandler(props.row.original);
                    }
                }} />
            }
            {props.addCommentBtnVisible && 
                <div ref={(node: any) => {props.addCommentBtnRef(node, props.row.original)}} 
                    className={`addCommentBtnWrapper addCommentBtnWrapperTableRow ${props.checkIfMarkedForCommentFilter(props.row.original) ? "activeAddCommentBtn" : ""}`} 
                    onClick={(e) => {
                        e.stopPropagation();
                        if (props.addCommentBtnClickHandler !== undefined) {
                            props.addCommentBtnClickHandler(props.row.original);
                        }
                    }} 
                    style={{right: "-30px", height: "54px", paddingLeft: "0", top: "-6px"}}>
                    {AdditionalIcon(AddCircleIcon)}
                </div>
            }
        </div>
        )
    }
    else if (props.objectType === "search-authors") {
        return (<div className={tableActionsStyle}>
            <PersonAdd {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.personAddClickHandler !== undefined) {
                    props.personAddClickHandler(props.row.original);
                }
            }} />
        </div>)
    }
    else if (props.objectType === "rasters") {
        return (
        <div ref={(node: any) => {if(props.addCommentBtnRef && !props.addCommentBtnVisible) props.addCommentBtnRef(node, props.row.original)}} className={tableActionsStyle} style={{position: "relative"}}>
            {!props.addCommentBtnVisible && (props.fieldName === undefined ? props.notEdit === undefined ? renderEditState("globalid") : null : renderEditState(props.fieldName))}
            {!props.addCommentBtnVisible &&
                <Delete title="usuń" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                    e.stopPropagation();
                    if (props.deleteClickHandler !== undefined) {
                        props.deleteClickHandler(props.row.original);
                    }
                }} />
            }
            {props.addCommentBtnVisible && 
                <div ref={(node: any) => {props.addCommentBtnRef(node, props.row.original)}} 
                    className={`addCommentBtnWrapper addCommentBtnWrapperTableRow ${props.checkIfMarkedForCommentFilter(props.row.original) ? "activeAddCommentBtn" : ""}`} 
                    onClick={(e) => {
                        e.stopPropagation();
                        if (props.addCommentBtnClickHandler !== undefined) {
                            props.addCommentBtnClickHandler(props.row.original);
                        }
                    }} 
                    style={{right: "-30px", height: "54px", paddingLeft: "0", top: "-6px"}}>
                    {AdditionalIcon(AddCircleIcon)}
                </div>
            }
        </div>)
    }
    else if (props.objectType === "research") {
        return (
        <div ref={(node: any) => {if(props.addCommentBtnRef && !props.addCommentBtnVisible) props.addCommentBtnRef(node, props.row.original)}} className={tableActionsStyle} style={{position: "relative"}}>
            {!props.addCommentBtnVisible && 
                <>
                    {!props.visibilityRows?.includes(props.row.original.itemGlobalId) && <Visibility title="podgląd" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                        e.stopPropagation();
                        if (props.visibilityClickHandler !== undefined) {
                            props.visibilityClickHandler(props.row.original);
                        }
                    }} />}
                    {props.visibilityRows?.includes(props.row.original.itemGlobalId) && <Close title="zamknij podgląd" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                        e.stopPropagation();
                        if (props.closeClickHandler !== undefined) {
                            props.closeClickHandler(props.row.original);
                        }
                    }} />}
                    <Delete title="usuń" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                        e.stopPropagation();
                        if (props.deleteClickHandler !== undefined) {
                            props.deleteClickHandler(props.row.original);
                        }
                    }} />
                </>
            }
            {props.addCommentBtnVisible && 
                <div ref={(node: any) => {props.addCommentBtnRef(node, props.row.original)}} 
                    className={`addCommentBtnWrapper addCommentBtnWrapperTableRow ${props.checkIfMarkedForCommentFilter(props.row.original) ? "activeAddCommentBtn" : ""}`} 
                    onClick={(e) => {
                        e.stopPropagation();
                        if (props.addCommentBtnClickHandler !== undefined) {
                            props.addCommentBtnClickHandler(props.row.original);
                        }
                    }} 
                    style={{right: "-30px", height: "54px", paddingLeft: "0", top: "-6px"}}>
                    {AdditionalIcon(AddCircleIcon)}
                </div>
            }
        </div>)
    }
    else if (props.objectType === "search-documents-publications") {
        return (<div className={tableActionsStyle}>
            <AddCircleIcon title="dodaj" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.addClickHandler !== undefined) {
                    props.addClickHandler(props.row.original);
                }
            }} />
        </div>)
    }
    else if (props.objectType === "manageDictProposals") {
        return (<div className={tableActionsStyle}>
            <DoNotDisturbOn title="odrzuć" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.doNotDisturbOnClickHandler !== undefined) {
                    props.doNotDisturbOnClickHandler(props.row.original);
                }
            }} />
            <CheckCircle title="zatwierdź" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.checkCircleClickHandler !== undefined) {
                    props.checkCircleClickHandler(props.row.original);
                }
            }} />
            {!props.visibilityRows?.includes(props.row.original.proposalObject.id) && <Visibility title="podgląd" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.visibilityClickHandler !== undefined) {
                    props.visibilityClickHandler(props.row.original);
                }
            }} />}
            {props.visibilityRows?.includes(props.row.original.proposalObject.id) && <Close title="zamknij podgląd" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                e.stopPropagation();
                if (props.closeClickHandler !== undefined) {
                    props.closeClickHandler(props.row.original);
                }
            }} />}
        </div>)
    }
    else if (props.objectType === "universal-edit") {
        return (
        <div ref={(node: any) => {if(props.addCommentBtnRef && !props.addCommentBtnVisible) props.addCommentBtnRef(node, props.row.original)}} className={tableActionsStyle} style={{position: "relative"}}>
            {!props.addCommentBtnVisible && renderEditState("itemGlobalId")}
            {!props.addCommentBtnVisible && 
                <Delete title="usuń" className="tableActionsFormIcons" {...PropsSVG} onClick={(e) => {
                    e.stopPropagation();
                    if (props.deleteClickHandler !== undefined) {
                        props.deleteClickHandler(props.row.original);
                    }
                }} />
            }
            {props.addCommentBtnVisible && 
                <div ref={(node: any) => props.addCommentBtnRef(node, props.row.original)} 
                    className={`addCommentBtnWrapper addCommentBtnWrapperTableRow ${props.checkIfMarkedForCommentFilter(props.row.original) ? "activeAddCommentBtn" : ""}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (props.addCommentBtnClickHandler !== undefined) {
                            props.addCommentBtnClickHandler(props.row.original);
                        }
                    }} 
                    style={{right: "-30px", height: "54px", paddingLeft: "0", top: "-6px"}}>
                    {AdditionalIcon(AddCircleIcon)}
                </div>
            }
        </div>
        )
    } else if (props.objectType === "notification") {
        return (<div className={tableActionsStyle}>
            {renderReadState("CZY_ODCZYTANE", 1)}
        </div>)
    } else if (props.objectType === "message") {
        return (<div className={tableActionsStyle}>
            {renderAttachment()}
            {renderReadState("STATUS_WIADOMOSCI_DOM", "odczytana")}
        </div>)
    } else if (props.objectType === "importantMessage") {
        return (<div className="tableActions-start">
            {renderIfImportant()}
        </div>)
    } else if (props.objectType === "taskSource") {
        return (<div className="tableActions-start">
            {renderTaskSource()}
        </div>)
    } else {
        return (
        <div className={tableActionsStyle}>
            {!checkIfInWaitingRoom() ? <AutoRenew title="aktualizuj kartę / koryguj protokół" style={iconStyle} className="tableActionsMainTablesIcons" onClick={(e) => {
                e.stopPropagation();
                if (props.autoRenewClickHandler !== undefined) {
                    props.autoRenewClickHandler(props.row);
                }
            }} /> :  
            <AutoRenewDisabled title="karta / protokół znajduje się w poczekalni" style={iconStyleDisabled} className="tableActionsMainTablesIcons" /> }
            {checkIfKR() &&
                <FindInPage title="dodaj protokół" style={iconStyle} className="tableActionsMainTablesIcons" onClick={(e) => {
                    e.stopPropagation();
                    if (props.findInPageClickHandler !== undefined) {
                        props.findInPageClickHandler(props.row);
                    }
                }} />
            }
            {!checkIfKR() &&
                <div style={emptyCSS}/>
            }
        </div>)
    }
}

export default TableActions;
